var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddSquareFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16712 3.51909C1 5.12549 1 7.41699 1 12C1 16.583 1 18.8745 2.16712 20.4809C2.54405 20.9997 3.00029 21.456 3.51909 21.8329C5.12549 23 7.41699 23 12 23C16.583 23 18.8745 23 20.4809 21.8329C20.9997 21.456 21.456 20.9997 21.8329 20.4809C23 18.8745 23 16.583 23 12C23 7.41702 23 5.12549 21.8329 3.51909C21.456 3.00029 20.9997 2.54405 20.4809 2.16712C18.8745 1 16.583 1 12 1C7.41699 1 5.12549 1 3.51909 2.16712C3.00029 2.54405 2.54405 3.00029 2.16712 3.51909ZM12.5238 8.46429C12.5238 8.24732 12.3479 8.07143 12.131 8.07143C11.914 8.07143 11.7381 8.24732 11.7381 8.46429V11.7381H8.46429C8.24732 11.7381 8.07143 11.914 8.07143 12.131C8.07143 12.3479 8.24732 12.5238 8.46429 12.5238H11.7381V15.7976C11.7381 16.0146 11.914 16.1905 12.131 16.1905C12.3479 16.1905 12.5238 16.0146 12.5238 15.7976V12.5238H15.7976C16.0146 12.5238 16.1905 12.3479 16.1905 12.131C16.1905 11.914 16.0146 11.7381 15.7976 11.7381H12.5238V8.46429Z",
    fill: "#276EF1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSquareFilled);
export default __webpack_public_path__ + "static/media/AddSquareFilled.1f2c5b3d6ebdef02e9cf15a7a2e0fee3.svg";
export { ForwardRef as ReactComponent };